var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxBusinessBriefcaseVersion1Outline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7854 7.04614H4.21617C3.43447 7.04614 2.80078 7.67984 2.80078 8.46153V19.7846C2.80078 20.5663 3.43447 21.2 4.21617 21.2H19.7854C20.5671 21.2 21.2008 20.5663 21.2008 19.7846V8.46153C21.2008 7.67984 20.5671 7.04614 19.7854 7.04614Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16929 2.80005H14.8308C15.2062 2.80005 15.5662 2.94917 15.8317 3.21461C16.0971 3.48004 16.2462 3.84005 16.2462 4.21543V7.0462H7.75391V4.21543C7.75391 3.84005 7.90303 3.48004 8.16846 3.21461C8.4339 2.94917 8.7939 2.80005 9.16929 2.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxBusinessBriefcaseVersion1Outline);
export default __webpack_public_path__ + "static/media/icon_24px_business-briefcase_version1_outline.71a72f8b9e378f03b8cae48d52ca730d.svg";
export { ForwardRef as ReactComponent };